import { _ as t } from "../internals/export.js";
import { m as a } from "../internals/math-sign.js";
var r = Math.abs,
  s = Math.pow;
t({
  target: "Math",
  stat: !0
}, {
  cbrt: function cbrt(t) {
    var n = +t;
    return a(n) * s(r(n), 1 / 3);
  }
});